import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=09f0464e&scoped=true&lang=pug"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0464e",
  null
  
)

export default component.exports